<template>
  <div>
    <div class="d-flex mb-1" style="font-size: 14px; color: #606266">
      <div
        class="side-frame-success"
        style="height: inherit;margin: 0;min-height: 21px;"
      ></div>
      <div>
        <el-tag
          size="mini"
          :type="
            formData.status === 'Y'
              ? 'success'
              : formData.status === 'D'
              ? 'danger'
              : formData.status === 'N'
              ? 'warning'
              : ''
          "
        >
          {{ formData.v_status || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span>
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>

    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_accountName') || '账户名称'"
            prop="accountName"
          >
            <el-input
              v-model="formData.accountName"
              :placeholder="$l('INDEX.tips_input_placeholder')"
              clearable
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_platform') || '平台'"
            prop="platformCode"
          >
            <dict-select
              v-model="formData.platformCode"
              url="/ecomorder/ecom/platform/select"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="small"
              :disabled="!!platformAccountCode"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <dynamicForm
        :gutter="10"
        :span="12"
        :disabled="disabled"
        :items="paramsTemplateItems"
        :value.sync="params"
      ></dynamicForm>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import dynamicForm from '@/components/dynamic-form'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    platformAccountCode: { type: String, default: '' },
  },
  components: { dynamicForm },
  data() {
    return {
      formData: {},
      params: {
      },
      paramsTemplate: {},
      rules: {
        accountName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        platformCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        params: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    this.$l('INDEX.tips_input_placeholder') || '请输入...'
                  )
                )
                return
              }

              try {
                JSON.parse(value)
                callback()
              } catch (error) {
                callback(new Error('请输入正确的JSON格式'))
              }
            },
          },
        ],
      },
      paramsTemplateItems: [],
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.paramsTemplateItems = []
      if (!this.platformAccountCode) return
      this.$api
        .ecomOrderPlatformAccountDetailApi({
          platformAccountCode: this.platformAccountCode,
        })
        .then((res) => {
          this.formData = res.body
          this.params = JSON.parse(this.formData.params)
          this.paramsTemplate = JSON.parse(this.formData.paramsTemplate) || {}
          Object.keys(this.paramsTemplate).forEach((e) => {
            const item = {
              el: this.paramsTemplate[e].name || 'input',
              id: e,
              title: e,
              props: this.paramsTemplate[e].props || {},
              attrs: this.paramsTemplate[e].attrs || {},
              required: this.paramsTemplate[e].required || false,
            }
            this.paramsTemplateItems.push(item)
          })
        })
    },
    async save() {
      this.formData.params = JSON.stringify(this.params)
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .ecomOrderPlatformAccountSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
      this.backDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
